import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (unavailability) =>
    present(
      repository
        .removeUnavailability(unavailability)
        .then(() => unavailability)
        .catch(() => Promise.reject(unavailability)),
    );
}

export type { Interactor };

export { createInteractor };
